// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
Vue.config.productionTip = false

// 配置手势库
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// 配置验证库
import Vuerify from 'vuerify'
Vue.use(Vuerify /*, add rules */)

// 配置store
import store from "@/store/index.js"
import { getToken, setToken, getCode, setCode } from '@/utils/functions'
import { jssdk_share } from '@/utils/jssdk'

// 配置路由
import router from "@/router/index"

// 配置axios
import axios from 'axios'
import qs from 'qs'
Vue.prototype.$axios = axios;

// 初始化axios
// axios.defaults.timeout = 5000;
axios.defaults.baseURL = process.env.API_ROOT;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// http请求拦截器
axios.interceptors.request.use(
    config => {

        // 处理token
        const token = getToken();
        if (token) {
            if (config.params) {
                config.params["access_token"] = token;
            } else {
                config.params = {
                    access_token: token,
                };
            }
        }

        if (process.env.WECHAT_SHARE) {
            // 如果在微信浏览器，则增加分享链接
            const signUrl = store.getters['jssdk/signUrl'];
            console.log(signUrl);
            if (signUrl) {
                if (config.params) {
                    config.params["shareUrl"] = encodeURIComponent(signUrl);
                } else {
                    config.params = {
                        shareUrl: encodeURIComponent(signUrl)
                    };
                }
            }
        }

        if (config.method === 'post' || config.method === 'put') {
            // 处理data
            config.data = qs.stringify(config.data);
            //    config.data = JSON.stringify(config.data);
        }

        return config
    },
    function (error) {
        return Promise.reject(error);
    }
);

// http响应拦截器
axios.interceptors.response.use(
    response => {
        // 如果返回值包含微信共享信息
        if (response.hasOwnProperty('data')) {
            if (response.data.hasOwnProperty('jssdk')) {
                jssdk_share(response.data.jssdk.config, response.data.jssdk.share);
            }
        }
        return response;
    },
    error => {
        console.log(error);
        switch (error.response.status) {
            case 302: {
                console.log(error.response);
                router.replace(error.response.data.message);
                break;
            }
            case 401: {
                // 没有登录则获取微信登录url并跳转页面
                setToken(null);
                setCode(null);
                axios.get("oauth/authorize", {
                    params: {
                        url: window.location.href
                    }
                }).then((response) => {
                    var url = response.data.url;
                    if( typeof(url) == 'string') {
                        if( response.data.hasOwnProperty('code')) {
                            setCode(response.data.code);
                        }
                        window.location.href = response.data.url;
                    } else {
                        router.push(url);
                    }
                })
                break;
            }
            case 403: {
                console.log(error.response);
                store.commit('alert/show', {
                    title: "出错啦！", 
                    message: "您的会员级别无法访问本内容，请点击升级查看详情。", 
                    buttons: [
                        { label: "返回", go: -1 },
                        { label: "升级", url: { path: "/user/member" } }
                    ]
                });
                break;
            }
            default: {
                var message = "未知错误";
                if (error.response.data.message) {
                    message = error.response.data.message;
                }
                store.commit('alert/show', {
                    title: "出错啦！", 
                    message: message, 
                    buttons: [
                        { label: "返回", go: -1 }
                    ]
                });
                break;
            }
        }
        return Promise.reject(error.response.data);
    }
);

//
router.beforeEach((to, from, next) => {

    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    // 处理是否置灰背景
    store.commit('dialog', to.meta.dialog);

    // 是否隐藏footer
    store.commit('weui/footer', to.meta.footer);

    //
    store.commit('loading', false);
    store.commit('jssdk/oldurl', document.URL);

    //
    var code = getCode();
    if (code) {
        // 如果authorize Code存在，则通过code获取token
        setCode(null);
        axios.get("oauth/token", {
            params: {
                code: code
            }
        }).then((response) => {
            var token = response.data.token;
            setToken(token);
            next();
        })
    } else {
        
        if (to.query.hasOwnProperty('from') && to.query.hasOwnProperty('isappinstalled')) {
            // 微信分享转发URL，去除链接中的isappinstalled，from
            var path = to.path;
            var query = to.query;
            delete query.isappinstalled;
            delete query.from;
            next({ path: path, query: query, replace: true });
        } else {
            console.log('nothing just next.')
            next();
        }
    }
});

router.afterEach(to => {

    store.commit('jssdk/url', window.location.origin + to.fullPath);
});

//
import VueMatomo from 'vue-matomo'

if (process.env.ANALYTICS_ENABLE) {
    
    Vue.use(VueMatomo, {
        // Configure your matomo server and site
        host: 'https://analytics.sharepai.net/',
        siteId: 1,

        // Enables automatically registering pageviews on the router
        router: router,

        // Enables link tracking on regular links. Note that this won't
        // work for routing links (ie. internal Vue router links)
        // Default: true
        enableLinkTracking: true,

        // Require consent before sending tracking information to matomo
        // Default: false
        requireConsent: false,

        // Whether to track the initial page view
        // Default: true
        trackInitialView: true,

        // Changes the default .js and .php endpoint's filename
        // Default: 'piwik'
        trackerFileName: 'piwik'
    });
}
// 配置Vue实例
import App from './App'

new Vue({
    router,
    store,
    components: { App },
    template: '<App/>'
}).$mount('#app');
 